import { render, staticRenderFns } from "./DefaultSlider.vue?vue&type=template&id=156392c4&scoped=true&"
import script from "./DefaultSlider.vue?vue&type=script&lang=js&"
export * from "./DefaultSlider.vue?vue&type=script&lang=js&"
import style0 from "./DefaultSlider.vue?vue&type=style&index=0&id=156392c4&scoped=true&lang=scss&"
import style1 from "./DefaultSlider.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156392c4",
  null
  
)

export default component.exports